module.exports = __webpack_public_path__ + "img/1491817180.3c2f67e9.jpg";